export default "__VITE_ASSET__CsrUKJ$4__"